import React from "react";
import { OverlayTrigger } from "react-bootstrap";

import styles from "./table.module.scss";

const TableTooltip = ({
	text,
	placement,
	children,
	className = "",
	titleTextColor = "white",
}) => {
	return (
		<OverlayTrigger
			placement={placement}
			overlay={props => (
				<div
					style={props.style}
					ref={props.ref}
					show={props.show.toString()}
					className={`${styles.tableTooltip}`}
				>
					<div
						className={`${styles.tableTooltipTextHolder} ${className}`}
					>
						<span
							className={styles.tableTooltipText}
							style={{ color: `${titleTextColor}` }}
						>
							{text}
						</span>
					</div>
				</div>
			)}
		>
			{children}
		</OverlayTrigger>
	);
};

export default TableTooltip;
